import Rectangle, { resizeRectangle } from './Rectangle';
import Ellipse, { resizeEllipse } from './Ellipse';
import SemiCircle, { resizeSemiCircle } from './SemiCircle';
import Triangle, { resizeTriangle } from './Triangle';
import RightTriangle, { resizeRightTriangle } from './RightTriangle';
import Diamond, { resizeDiamond } from './Diamond';
import LeafRight, { resizeLeafRight } from './LeafRight';
import LeafLeft, { resizeLeafLeft } from './LeafLeft';
import Octagon, { resizeOctagon } from './Octagon';
import Pentagon, { resizePentagon } from './Pentagon';
import Hexagon, { resizeHexagon } from './Hexagon';
import QuarterCircle, { resizeQuarterCircle } from './QuarterCircle';
import Parallelogram, { resizeParallelogram } from './Parallelogram';
import Trapezoid, { resizeTrapezoid } from './Trapezoid';
import BlockArrow, { resizeBlockArrow } from './BlockArrow';
import BlockArrowIndent, { resizeBlockArrowIndent } from './BlockArrowIndent';
import Ribbon, { resizeRibbon } from './Ribbon';
import DoubleBlockArrow, { resizeDoubleBlockArrow } from './DoubleBlockArrow';

import { BasicShapeType } from '../BasicShapeWidget.types';

export const SHAPE_TYPE_MAP = {
  [BasicShapeType.Rectangle]: Rectangle,
  [BasicShapeType.Ellipse]: Ellipse,
  [BasicShapeType.SemiCircle]: SemiCircle,
  [BasicShapeType.Triangle]: Triangle,
  [BasicShapeType.RightTriangle]: RightTriangle,
  [BasicShapeType.Diamond]: Diamond,
  [BasicShapeType.LeafLeft]: LeafLeft,
  [BasicShapeType.LeafRight]: LeafRight,
  [BasicShapeType.Pentagon]: Pentagon,
  [BasicShapeType.Hexagon]: Hexagon,
  [BasicShapeType.Octagon]: Octagon,
  [BasicShapeType.QuarterCircle]: QuarterCircle,
  [BasicShapeType.Parallelogram]: Parallelogram,
  [BasicShapeType.Trapezoid]: Trapezoid,
  [BasicShapeType.BlockArrow]: BlockArrow,
  [BasicShapeType.BlockArrowIndent]: BlockArrowIndent,
  [BasicShapeType.Ribbon]: Ribbon,
  [BasicShapeType.DoubleBlockArrow]: DoubleBlockArrow,
};

export const SHAPE_RESIZE_MAP = {
  [BasicShapeType.Rectangle]: resizeRectangle,
  [BasicShapeType.Ellipse]: resizeEllipse,
  [BasicShapeType.SemiCircle]: resizeSemiCircle,
  [BasicShapeType.Triangle]: resizeTriangle,
  [BasicShapeType.RightTriangle]: resizeRightTriangle,
  [BasicShapeType.Diamond]: resizeDiamond,
  [BasicShapeType.LeafRight]: resizeLeafRight,
  [BasicShapeType.LeafLeft]: resizeLeafLeft,
  [BasicShapeType.Pentagon]: resizePentagon,
  [BasicShapeType.Hexagon]: resizeHexagon,
  [BasicShapeType.Octagon]: resizeOctagon,
  [BasicShapeType.QuarterCircle]: resizeQuarterCircle,
  [BasicShapeType.Parallelogram]: resizeParallelogram,
  [BasicShapeType.Trapezoid]: resizeTrapezoid,
  [BasicShapeType.BlockArrow]: resizeBlockArrow,
  [BasicShapeType.BlockArrowIndent]: resizeBlockArrowIndent,
  [BasicShapeType.Ribbon]: resizeRibbon,
  [BasicShapeType.DoubleBlockArrow]: resizeDoubleBlockArrow,
};
